import React from 'react'
import Fade from '../../Utils/Fade'
import {isEmpty} from 'lodash'

export default class Eligible extends React.PureComponent {
    render() {
        const {product, processPrev, processEnroll, translationData} = this.props
        return (
            <div className="col-md-8 col-md-offset-2">
                {
                    !isEmpty(translationData) ?
                        <Fade duration={0.5}>
                            <div className="eligible-content">
                                <h1>{translationData.eligibleMsg.title}</h1>
                                <p>{translationData.eligibleMsg.content}</p>
                                {/* eslint-disable-next-line */}
                                <a>{translationData.eligibleMsg.link}</a>
                            </div>
                            <div className="eligible-btn">
                                <button
                                    className="btn btn-default semibold process-prev"
                                    onClick={processPrev}>
                                    {translationData.back}
                                </button>
                                <button
                                    className="btn btn-default semibold process-next"
                                    onClick={() => processEnroll(product.name)}>
                                    {translationData.apply}
                                </button>
                            </div>
                            <div className="eligible-introduce">
                                <p>{translationData.eligibleMsg.comment}</p>
                            </div>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}